module.exports = __webpack_public_path__ + "img/T2A_rc_6.31086b6b.png";